import logo from "./logo.svg";
import "./App.css";
import Nav from "./Compounent/Nav/Nav";
import Hero from "./Compounent/Hero/Hero";
import Buy from "./Compounent/Buy/Buy";
import About from "./Compounent/About/About";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Info from "./Compounent/Info/Info";
import FAQ from "./Compounent/FAQ/FAQ";
import Footer from "./Compounent/Footer/Footer";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";
import Web3 from "web3";
import { beeplanABI, beeplanAddress } from "./Compounent/Contract/BeePlan";
import { usdtTokenABI, usdtTokenAddress } from "./Compounent/Contract/USDT";
import { beeTokenABI, beeTokenAddress } from "./Compounent/Contract/BeeToken";
import { useEffect, useState } from "react";

function App() {
  const { address: account, chainId } = useWeb3ModalAccount();
  const isBSC = chainId === 97;

  const [round, setRound] = useState(0);
  const [winner, setWinner] = useState(0);
  const [block, setBlock] = useState(0);
  const [jackpot, setJackpot] = useState(0);
  const [splitCountdown, setSplitCountdown] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const web3 = new Web3(window.ethereum);
  const beePlanContract = new web3.eth.Contract(beeplanABI, beeplanAddress);
  const USDTContract = new web3.eth.Contract(usdtTokenABI, usdtTokenAddress);
  const BeeTokenContract = new web3.eth.Contract(beeTokenABI, beeTokenAddress);

  useEffect(() => {
    let interval;

    const fetchAll = async () => {
      if (!account || !isBSC) {
        setErrorMessage("Please connect to Binance Smart Chain Testnet.");
        return;
      }

      try {
        const currentRoundStr = await beePlanContract.methods
          .currentRound()
          .call();
        const currentRound = Number(currentRoundStr);
        setRound(currentRound);

        const previous = currentRound - 1;

        const [jackpotData, winnerData, remainingBlocks, splitCountdownData] =
          await Promise.all([
            beePlanContract.methods.getJackpot(currentRound).call(),
            beePlanContract.methods.rounds(currentRound).call(),
            beePlanContract.methods.getRemainingBlocks(currentRound).call(),
            beePlanContract.methods.getBlocksUntilSpawn(previous).call(),
          ]);

          const jack = parseFloat(jackpotData) / 1e18;
          const usd = jack.toFixed(4)
        const winn = winnerData.count;
        setJackpot(usd);
        setWinner(Number(winn));
        setBlock(Number(remainingBlocks));
        setSplitCountdown(Number(splitCountdownData));

        // console.log(splitCountdownData)
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessage("An error occurred while fetching contract data.");
      }
    };

    if (account && isBSC) {
      fetchAll(); // initial fetch
      interval = setInterval(fetchAll, 1000); // update every second
    }

    return () => clearInterval(interval);
  }, [account, isBSC]);
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Hero
          round={round}
          winner={winner}
          block={block}
          splitCountdown={splitCountdown}
          jackpot={jackpot}
        />
        <Routes>
          <Route
            path="/"
            element={
              <Buy
                round={round}
                winner={winner}
                block={block}
                jackpot={jackpot}
                splitCountdown={splitCountdown}
              />
            }
          />
          <Route path="/info" element={<Info />} />
          <Route path="/FAQ" element={<FAQ />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
